module.exports = __webpack_public_path__ + "img/program11.4c4ff83c.png";